import { render, staticRenderFns } from "./ProcurationStep3.vue?vue&type=template&id=18b1105d&scoped=true&"
import script from "./ProcurationStep3.vue?vue&type=script&lang=js&"
export * from "./ProcurationStep3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b1105d",
  null
  
)

export default component.exports